import { EventEmitter } from 'eventemitter3';
import { LoaderStats } from 'hls.js';

import { HlsStatsReporterEvent } from './HlsStatsReporterEvent';
import { transferToBitsPerSec } from './HlsStatsUtils';

export class HlsStatsReporter extends EventEmitter {
	public reportFragBuffered(frag: any, stats: LoaderStats, bwEstimatorValueBitsPerSec: number, level: any, isPrimaryPlayer: boolean = true): void {
		const fileName: string = (frag.url as string).split('/').pop().split('?')[0];
		const requestToParsedDurationMs: number = stats.parsing.end - stats.loading.first;
		const requestBitsPerSec: number = transferToBitsPerSec(requestToParsedDurationMs, stats.loaded);

		const fragReportedData = {
			bwEstimatorValueBitsPerSec,
			fileName,
			isPrimaryPlayer,
			level: frag.level,
			levelBitsPerSec: level.bitrate,
			url: frag.url,
			requestLatencyMs: stats.loading.first - stats.loading.start,
			loadDurationMs: stats.loading.start - stats.loading.end,
			parsingDurationMs: stats.parsing.end - stats.loading.end,
			bufferAppendDurationMs: stats.buffering.end - stats.parsing.end,
			requestToParsedDurationMs,
			requestBitsPerSec,
			sizeBytes: stats.loaded,
			tBufferedMs: +Date.now()
		};

		this.emit(HlsStatsReporterEvent.FRAG_REPORTED, fragReportedData);
	}

	public reportLevelSwitched(eventData: any, isPrimaryPlayer: boolean = true): void {
		const levelReportedData = {
			isPrimaryPlayer
		};

		this.emit(HlsStatsReporterEvent.LEVEL_REPORTED, levelReportedData);
	}
}

export const hlsStatsReporterInstance = new HlsStatsReporter();
